const StopIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => {
  return (
    <svg viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M18.141 4.00001C17.211 3.04886 16.1001 2.29342 14.8737 1.7782C13.6473 1.26297 12.3302 0.998383 11 1.00001C5.47701 1.00001 1.00001 5.47701 1.00001 11C0.996689 13.6183 2.02366 16.1327 3.85901 18M3.85901 18C4.78897 18.9512 5.89987 19.7066 7.12627 20.2218C8.35267 20.737 9.66978 21.0016 11 21C16.523 21 21 16.523 21 11C21.0032 8.38158 19.9758 5.86708 18.14 4.00001L3.85901 18Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StopIcon;
